import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import HeaderWrapper from "../../Header/HeaderWrapper";
import TextMainBannerWrapper from "../../TextMainBanners/TextMainBannerWrapper";
import Spinner from "../../Spinner";
import { formatDate } from "../../../Helper/Helper";
import { SendPostRequest } from "../../../http";
import FooterWrapper from "../../Footer/FooterWrapper";

function SideImagesNews() {
  const [newsData, setNewsData] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    getNewsData();
    window.scrollTo(0, 0);
  }, []);

  const getNewsData = async () => {
    setLoading(true);
    try {
      const response = await SendPostRequest("news/list");
      setNewsData(response?.data);
    } catch (error) {
      console.error("Error fetching news:", error);
    } finally {
      setLoading(false);
    }
  };
  const [isMobile, setIsMobile] = useState(window.innerWidth <= 768);
  
    useEffect(() => {
      const handleResize = () => setIsMobile(window.innerWidth <= 768);
      window.addEventListener("resize", handleResize);
      return () => window.removeEventListener("resize", handleResize);
    }, []);

  return (
    <div className="page-wrapper-inner">
      <div className="page-wrapper-inner">
        <HeaderWrapper />
        <TextMainBannerWrapper Heading="News and Updates" Image="theme-2-banner-news.webp"/>

        <div className="container">
          {loading ? (
            <div className="d-flex justify-content-center py-5">
              <Spinner />
            </div>
          ) : newsData?.length > 0 ? (
            <div className="blog-section py-5">
              <div className="row blog-list blog-list-style-1 br-style">
                {newsData.map((item, index) => (
                  <div className="col-md-6 mb-5" data-animation="fadeInLeft" key={index}>
                    <div className="blog-inner" style={{ borderBottom: "1px dotted #000", paddingBottom:isMobile ? "5px" : "30px", }}>
                      <div className="media list-post">
                        {/* <div className="blog-thumb relative">
                          <img
                            src={item?.image || "images/blog/blog-list/blog-1.jpg"}
                            className="img-fluid"
                            style={{ width: "140px", height: "140px" }}
                            alt="blog-img"
                          />
                        </div> */}
                        <div
                          className="blog-thumb relative"
                          style={{
                            backgroundImage: `url(${item?.image || "images/blog/blog-list/blog-1.jpg"})`,
                            backgroundSize: "cover",
                            backgroundPosition: "top center",
                            width: isMobile ? "100%" : "140px",
                            height: isMobile ? "150px" : "140px",
                            marginBottom: isMobile ? "15px" : "0px",
                            backgroundRepeat: "no-repeat"
                          }}
                        ></div>

                        <div className="media-body">
                          <div className="top-meta margin-bottom-10">
                            <ul className="top-meta-list">
                              <li>
                                <div className="post-date text-white">
                                  <Link className=" text-white side-img-news-date" to={`/news/detail/${item?.slug}`}>
                                    <i className="ti-calendar text-white"></i> {formatDate(item?.date)}
                                  </Link>
                                </div>
                              </li>
                            </ul>
                          </div>
                          <div className="blog-title ">
                            <h5 className="margin-bottom-5">
                              <Link
                                to={`/news/detail/${item?.slug}`}
                                className="blog-name text-black"
                              >
                                {item?.title}
                              </Link>
                            </h5>
                          </div>
                          <div className="entry-content typo-black">
                            <p className="mb-0">
                              <div
                                dangerouslySetInnerHTML={{
                                  __html: (() => {
                                    const plainText = item?.content?.replace(/<[^>]*>/g, "") || "";
                                    return plainText.substring(0, 90) + (plainText.length > 90 ? "..." : "");
                                  })(),
                                }}
                              />

                            </p>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                ))}
              </div>
            </div>
          ) : (
            <div className="col-12 text-center my-5 py-5">
              <h4>No Record Available</h4>
            </div>
          )}
        </div>

        <FooterWrapper />
      </div>
    </div>
  );
}

export default SideImagesNews;